import { createStore } from 'redux';
import enhancers from './enhancers';
import rootReducer from './rootReducer';

export default (defaultState = {}) => createStore(rootReducer, defaultState, enhancers);
